import { buildHeaders } from "src/utils/apiUtils";

let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

loadConfig().then(() => {
});

// Function to handle fetch requests (auth via HttpOnly cookies)
export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {
  const headers = await buildHeaders(BASE_URL);
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      ...options,
      headers,
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    //////console.log(error)
    //console.log(error);
  }
}


export async function deleteImpactedAreasApi(id: string): Promise<void> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/impacted-areas/${id}`, {
      credentials: "include",
      method: 'DELETE',
      headers,
    });
    if (!response.ok) {
      //console.log('Failed to delete question');
    }
  } catch (error) {
    //console.log('Failed to delete question');
  }
}






/** WAPT08: Valid quarter values (matches backend). */
const VALID_QUARTERS = /^(1|2|3|4|01|02|03|04|Q1|Q2|Q3|Q4)$/i;

export async function createImpactedAreas(body: Record<string, any>): Promise<any> {
  try {
    // name required 3-250; description optional, if present 3-2500
    const name = body?.name != null ? String(body.name).trim() : '';
    const description = body?.description != null ? String(body.description).trim() : '';
    if (!name) {
      return { success: false, message: 'Name is required' };
    }
    if (name.length < 3 || name.length > 250) {
      return { success: false, message: 'Name must be between 3 and 250 characters' };
    }
    if (description.length > 0 && (description.length < 3 || description.length > 2500)) {
      return { success: false, message: 'Description must be between 3 and 2500 characters when provided' };
    }
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/impacted-areas`, {
      method: "POST",
      headers,
      credentials: "include",
      body: JSON.stringify({ name, description: description || '' }),
    });

    const data = await response.json();

    if (!response.ok) {
      const errorMessage = data?.message || "Failed to create impacted area.";
      
      if (response.status === 401 || response.status === 403) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }

      //console.log(errorMessage);
    }

    return data; // Return the full response if needed
  } catch (error: any) {
    //console.error("API Error:", error.message);
    //console.log(error.message || "An unexpected error occurred.");
  }
}



export async function updateImpactedAreasApi(id: any, body: any): Promise<void> {
  try {
    // name 3-250 when provided; description optional, 3-2500 when provided
    if (body?.name !== undefined) {
      const name = String(body.name).trim();
      if (name.length < 3 || name.length > 250) throw new Error('Name must be between 3 and 250 characters');
      body = { ...body, name };
    }
    if (body?.description !== undefined && body?.description !== null && String(body.description).trim() !== '') {
      const description = String(body.description).trim();
      if (description.length < 3 || description.length > 2500) throw new Error('Description must be between 3 and 2500 characters when provided');
      body = { ...body, description };
    }
    const headers = await buildHeaders(BASE_URL);
    const fullUrl = `${BASE_URL}/impacted-areas/${id}`;
    const response = await fetch(fullUrl, {
      credentials: "include",
      method: "PUT",
      headers,
      
      body: JSON.stringify(body),
    });

    const data = await response.json();
    //console.log("Update API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to update");
    }

    return data; // Return the response data
  } catch (error) {
    //console.error("Error in updateRiskApi:", error); // Log the error
    //console.log("Failed to update risk");
  }
}




interface ImpactAreaResponse {
  name: string;
  description?: string;

}



export async function fetchOneImpactedAreasApi(endpoint: string): Promise<ImpactAreaResponse | null> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: "GET",
      headers,
      credentials: "include",
    });
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}
